import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApplicationCounty, ApplicationCountyClient, PagedListOfApplicationCounty} from './api.client';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';

// 003-retire-ngrx (US2): the applicationCounty slice went component-local.
// Implementation-time re-audit overturned the planning verdict of "shared":
// the manage page already reconciles against the :id route param and fetches
// by id when the in-memory county doesn't match (the deep-link path), and the
// fund-types store stream was written but never read (the page uses the
// direct PledgeTypeService fetch). The list->detail store handoff only saved
// one GET; the pages now fetch on load.
@Injectable()
export class ApplicationCountyService {
    constructor(private _http: HttpClient,
                private _applicationCountyApiClient: ApplicationCountyClient,
                private _notificationService: NotificationService
    ) {
    }

    searchCounties(
        searchValue: string,
        sortName: string,
        descending: boolean,
        limit: number,
        offset: number,
    ): Observable<PagedListOfApplicationCounty> {
        return this._applicationCountyApiClient.searchApplicationCounties(
            searchValue,
            sortName,
            null,
            descending,
            limit || 10,
            offset || 0
        ).pipe(share());
    }

    getApplicationCountyById(id: string): Observable<ApplicationCounty> {
        return this._applicationCountyApiClient.retrieveApplicationCountyById(id).pipe(share());
    }

    updateApplicationCounty(applicationCounty: ApplicationCounty): Observable<ApplicationCounty> {
        const request = this._applicationCountyApiClient.updateApplicationCounty(applicationCounty).pipe(share());
        this._notificationService.showSuccess('Attempting to update Application County.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Application County Successfully Updated!');
            }, error: (err) => {
                this._notificationService.showError(getMessageFromException(err));
            }, complete: () => {

            }
        });
        return request;
    }
}
